
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import BottomNavBar from './BottomNavBar'; // 이전 답변에서 만든 네비게이션 바
import ImagePopup from '../components/ImagePopup';
import React, { useState, useEffect, useCallback } from 'react';

// 메인 네비게이션 아이템 목록 (App.js에서 가져온다고 가정)
const MAIN_NAV_ITEMS = [
    { name: '홈', iconName: 'home', path: '/' },
    { name: '패션', iconName: 'fashion', path: '/rating' },
    { name: '피드', iconName: 'feed', path: '/feed' },
    { name: '응모', iconName: 'draw', path: '/event' },
    { name: 'MY', iconName: 'profile', path: '/my' },
];


const Layout = ({ children }) => {
        const navigate = useNavigate();
    // 현재 경로를 가져와서 내비게이션 바의 활성화 상태를 결정
    const location = useLocation(); 
        const [isPopupOpen, setIsPopupOpen] = useState(false);

    // 라우팅 처리 함수 (useNavigate를 사용하여 페이지 이동 구현)
    const handleNavigation = (path) => {
        console.log(path)
        // 실제 라우팅 로직 (App.js에서 useNavigate를 가져왔다고 가정)
        if(path != '/my'){
        navigate(path);
        }else{
                const savedToken = localStorage.getItem('user');
            const storedUserObject = JSON.parse(savedToken);
            if(storedUserObject.username == 'temp'){
                        navigate('/login');

            }else{
                        navigate(path);
            }
            //     console.log(storedUserObject.username)
            // setIsPopupOpen(true);
        }
        console.log(`페이지 이동 요청: ${path}`);
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
    };


    return (
        <div style={styles.mainContainer}>
                      <ImagePopup 
                                  isOpen={isPopupOpen} 
                                  onClose={handleClosePopup} 
                              />
            
            {/* ------------------------------------- */}
            {/* 페이지 콘텐츠 영역 (라우팅에 따라 변경) */}
            <div style={styles.contentArea}>
               <Outlet />
            </div>
            {/* ------------------------------------- */}

            {/* 네비게이션 바 (고정): 라우팅 변경 시에도 재로딩되지 않고 유지됨 */}
            <BottomNavBar 
                activePath={location.pathname} // 현재 경로를 기반으로 활성화 상태 지정
                items={MAIN_NAV_ITEMS}
                onItemClick={handleNavigation}
            />
        </div>
    );
};

// 스타일 객체
const styles = {
    mainContainer: {
        maxWidth: '420px',
        margin: '0 auto',
        minHeight: '100vh',
        boxShadow: '-5px 0 2px -5px rgb(214, 214, 214), 5px 0 2px -5px rgb(214, 214, 214)',
    },
    contentArea: {
        // 네비게이션 바의 높이(60px)만큼 하단 패딩을 주어 콘텐츠가 가려지는 것을 방지
        paddingBottom: '60px', 
    }
};

export default Layout;